import Glide from '@glidejs/glide';

let glideVideos = new Glide('.glide-videos', {
  type: 'carousel',
  perView: 1.25,
  focusAt: 'center'
});
glideVideos.mount();

function resetFrame() {
  const activeSlideIframe = document.querySelector(`.glide__slides .glide__slide--active iframe`);
  if (activeSlideIframe) {
    activeSlideIframe.src = activeSlideIframe.src;
  }
}

// reset videos when swiped so that we don't have multiple videos playing at once
glideVideos.on('run.before', resetFrame);

